export const getRuntimeWildcardDomain = () => (window.GLOBAL_INFO?.runtimeWildcardDomain || '').trim().toLowerCase();
export const parseWildcardHost = (host, wildcardDomain = getRuntimeWildcardDomain()) => {
    const wd = (wildcardDomain || '').trim().toLowerCase();
    if (!wd)
        return null;
    const h = (host || '').toLowerCase().split(':')[0];
    const re = new RegExp(`^([^.]+)\\.${wd.replace(/\./g, '\\.')}$`);
    const m = h.match(re);
    if (!m)
        return null;
    const sub = m[1];
    const idx = sub.lastIndexOf('-');
    let projectId;
    let env;
    if (idx === -1) {
        projectId = sub;
        env = 'prod';
    }
    else {
        projectId = sub.slice(0, idx);
        env = sub.slice(idx + 1);
    }
    if (!projectId || !env)
        return null;
    return { projectId, env, pathPrefix: '/page' };
};
export const isWildcardHost = (host = location.host) => !!parseWildcardHost(host);
export const buildWildcardHost = ({ projectId, env, wildcardDomain = getRuntimeWildcardDomain(), port = '', }) => {
    const wd = (wildcardDomain || '').trim().toLowerCase();
    const pid = (projectId || '').trim();
    const targetEnv = (env || '').trim();
    if (!wd || !pid || !targetEnv)
        return null;
    const sub = targetEnv === 'prod' ? pid : `${pid}-${targetEnv}`;
    const purePort = `${port || ''}`.trim();
    const host = `${sub}.${wd}`.toLowerCase();
    return purePort ? `${host}:${purePort}` : host;
};
